import styled, { css } from 'styled-components'
import { ThemeColorsKeysType } from 'src/components/Core/Styles/theme'
import { IconSvgProps } from './types'

// eslint-disable-next-line
export const Svg = styled('svg')<IconSvgProps | any>`
  outline: none;
  margin: ${props => props.svgMargin || '4px'};
  cursor: ${props => props.cursor || 'initial'};
  background-color: ${props => props.backgroundColor};
  ${props =>
    props.hoverColor &&
    css`
      &:hover {
        path {
          fill: ${props.theme.colors.main?.[
    props.color === 'blank' || props.color === 'background'
      ? 'ultraGreen'
      : 'ultraViolet'
  ]};
        }
      }
    `}
`

export const Path = styled('path')`
  fill: ${props =>
    props.theme.colors?.main?.[props.color as ThemeColorsKeysType] || 'dark'};
`
